<template src="./Product.html"></template>
<style lang="scss" scoped src="./Product.scss"></style>
<script>
import {
    SfAddToCart,
    SfBreadcrumbs,
    SfButton,
    SfHeading,
    SfIcon,
    SfImage,
    SfQuantitySelector,
    SfAccordion,
    SfLoader,
    SfModal,
    SfLink
} from '@storefront-ui/vue';

import {Product} from '@/models/product';
import Api from "@/api/Api";
import {OrkProductGallery, OrkLoader, OrkStock, OrkPrice} from "@/components/Ork";
import Locales from "@/utils/locales";

import icons from "@/utils/icons";

import {filterData} from "@/utils/categoryFilter";

import RelatedProduct from "@/components/Product/RelatedProduct";
import {LightProduct} from "@/models/product";
import Vue from "vue";
import OpenGraph from "@/utils/openGraph";
import GtagEvent from "@/utils/GtagEvent";

const {htmlToText} = require("html-to-text");
export default {
    name: 'Product',
    layout: 'product-layout',
    components: {
        SfAddToCart,
        SfBreadcrumbs,
        SfImage,
        SfHeading,
        SfLoader,
        SfIcon,
        OrkPrice,
        SfButton,
        SfQuantitySelector,
        SfAccordion,
        SfModal,
        OrkProductGallery,
        OrkLoader,
        OrkStock,
        RelatedProduct,
        SfLink
    },
    data() {
        return {
            locale: Locales.getLocaleCode(),
            icons: icons,
            index: null,
            breadcrumbs: [],
            breadcrumbsLD: null,
            productLD: null,
            showWishList: process.env.VUE_APP_WISHLIST === 'true',
            relatedProduct: {
                products: [],
                loading: true,
                headingTitle: this.$t('product.relatedProduct.title'),
                subHeadingTitle: this.$t('product.relatedProduct.subTitle'),
                messageError: this.$t('product.relatedProduct.errorMessage'),
                error: false,
            },
            shareOptions: [
                {
                    name: "Facebook",
                    icon: icons.facebook,
                    color: 'white',
                    bgColor: '#4267b2',
                    baseUrl: 'https://www.facebook.com/share.php?u=',
                    frameSize: ',width=585,height=368'
                },
                {
                    name: "Twitter",
                    icon: icons.twitter,
                    color: 'white',
                    bgColor: '#55acee',
                    baseUrl: 'https://twitter.com/intent/tweet?url=',
                    frameSize: ',width=585,height=261'
                },
                {
                    name: "Pinterest",
                    icon: icons.pinterest,
                    color: 'white',
                    bgColor: '#cb2027',
                    baseUrl: 'https://pinterest.com/pin/create/button/?url=',
                    frameSize: ',width=500,height=600'
                },
                {
                    name: "Linkedin",
                    icon: icons.linkedIn,
                    color: 'white',
                    bgColor: '#0077b5',
                    baseUrl: 'https://www.linkedin.com/shareArticle?mini=true&url=',
                    frameSize: ',width=500,height=700'
                },
            ],
            fromCategory: null,
            urlEncode: encodeURI(window.location.href),
            product: null,
            selectedProduct: {},
            loading: false,
            error: false,
            configurables: null,
            quantity: 1,
            AddTocartLoading: false

        };
    },
    computed: {
        customer() {
            return this.$store.getters.getProfile;
        },
        sortedAttribute: {
            get() {

                const sort = Object.fromEntries(
                    Object.entries({...this.selectedProduct.attributeValuesByAttributeName})
                        .sort(([KeyA, a], [KeyB, b]) => {

                            if (!a.value) {
                                delete this[KeyA]
                            }
                            if (!b.value) {
                                delete this.selectedProduct.attributeValuesByAttributeName[KeyB]
                            }
                            return a.label < b.label ? -1 : 1;
                        })
                );
                for (const [key, value] of Object.entries(sort)) {
                    if (!value.value) {
                        delete sort[key]
                    }
                }

                return sort
            }
        },
        currentCart: {
            get() {
                return this.$store.getters.getCart;
            }
        },
        categoryTree: {
            get() {
                return this.$store.getters.getCategoryTree
            }
        },
        activeCategory: {

            get() {
                return sessionStorage.getItem('activeCategory')
            }
        },
        computedRelatedProducts: {
            get() {
                return this.relatedProduct.products;
            },
        }
    },
    mounted() {
        this.loadProduct();
        // this.loadScript("/assets/js/facebookEvents/product.js", "facebookEvent")

    },
    watch: {
        customer(newCustomer, oldCustomer) {
            let nc = {...newCustomer}
            let oc = {...oldCustomer}
            if (oc && nc.email !== oc.email) {

                this.loadProduct()
            }
        },
        $route: 'loadProduct'
    },
    methods: {
        loadScript(src, id) {
            const existingScript = document.getElementById(id);
            return new Promise(function (resolve, reject) {
                if (!existingScript) {
                    let script = document.createElement('script');
                    script.src = src;
                    script.id = id
                    script.onload = () => resolve(script);
                    script.onerror = () => reject(new Error(`Script load error for ${src}`));
                    document.head.append(script);
                } else {
                    existingScript.remove()
                    let script = document.createElement('script');
                    script.src = src;
                    script.id = id

                    script.onload = () => resolve(script);
                    script.onerror = () => reject(new Error(`Script load error for ${src}`));

                    document.head.append(script);
                }
            });

        },
        getRelatedProduct(relatedProduct) {
            this.relatedProduct.loading = true;
            Api.product.getBySkuList(relatedProduct)
                .then(data => {
                    this.relatedProduct.products = []
                    for (let lightProduct of data) {
                        this.relatedProduct.products.push(LightProduct.of(lightProduct));
                    }
                })
                .catch(err => {
                    this.relatedProduct.error = true;
                    this.relatedProduct.loading = false;

                }).finally(() => {
                this.relatedProduct.loading = false;
            })
        },
        getSelectedProduct(product) {
            if (product.children) {
                return product.children.find((p) => {
                    if (p.offers && product.defaultOffer) {
                        return p.offers.find(o => o.id === product.defaultOffer?.id) !== undefined
                    }
                });
            }
            return product
        },
        getProductMarketing() {
            const descEl = document.querySelector('head meta[name="description"]');
            const titleEl = document.querySelector('head title');

            const ogUrl = document.querySelector('head meta[property="og:url"]');
            const ogType = document.querySelector('head meta[property="og:type"]');
            const ogTitle = document.querySelector('head meta[property="og:title"]');
            const ogDesc = document.querySelector('head meta[property="og:description"]');
            const ogPrice = document.querySelector('head meta[property="og:price:amount"]');
            const ogImg = document.querySelector('head meta[property="og:image" ]');
            if (this.selectedProduct.seoTitle && this.selectedProduct.seoTitle.value) {
                titleEl.textContent = this.selectedProduct.seoTitle.value;
                ogTitle.setAttribute('content', this.selectedProduct.seoTitle.value);
            } else {
                titleEl.textContent = this.$i18n.t('seo.defaultTitle', {pageName: this.selectedProduct.name});
                ogTitle.setAttribute('content', this.$i18n.t('seo.defaultTitle', {pageName: this.selectedProduct.name}));
            }
            if (this.selectedProduct.descriptionLong) {
                descEl.setAttribute('content', htmlToText(this.selectedProduct.descriptionLong.value, {
                    wordwrap: 150,
                    ellipsis: '...'
                }));
                ogDesc.setAttribute('content', htmlToText(this.selectedProduct.descriptionLong.value, {
                    wordwrap: 150,
                    ellipsis: '...'
                }));
            } else {
                descEl.setAttribute('content', this.$i18n.t('seo.productDescription', {productName: this.selectedProduct.name}));
                ogDesc.setAttribute('content', this.$i18n.t('seo.productDescription', {productName: this.selectedProduct.name}));
            }
            ogUrl.setAttribute('content', window.location.origin + this.$router.currentRoute.fullPath)
            ogImg.setAttribute('content', this.selectedProduct.pictureCover.src)
            ogTitle.setAttribute('content', this.selectedProduct.name)
            ogType.setAttribute('content', 'product')
            ogPrice.setAttribute('content', this.selectedProduct.discountPrice ? this.selectedProduct.discountPrice : this.selectedProduct.defaultOffer.price.taxIncluded)

            this.productLD = OpenGraph.generateProduct(this.selectedProduct)
        },
        loadProduct() {
            this.loading = true;
            Api.product.getBySlug(this.$route.params.productSlug)
                .then(data => {

                    this.product = Product.of(data);
                    this.selectedProduct = this.getSelectedProduct(this.product);

                    if (this.product.configurableAttributes) {
                        this.getConfigurable(this.product);
                    }

                    if (this.product.relatedProduct) {
                        const relatedProduct = JSON.parse(this.product.relatedProduct.value).toString();
                        this.getRelatedProduct(relatedProduct);
                    }

                    this.setBreadcrumbs();
                    this.getProductMarketing();
                    if (!window['disable-facebook']) {

                        fbq('track', "ViewContent");
                    }
                    GtagEvent.viewItem(this.selectedProduct, this.activeCategory, this.currentCart)
                })
                .catch((e) => {
                    console.error(e);
                    if (e.status === 404) {
                        this.$router.push('/404').catch();
                        this.$store.dispatch('sendNotification', {
                            type: 'danger',
                            message: this.$i18n.t('errors.notfound'),
                            icon: icons.error
                        });
                    } else {
                        this.$store.dispatch('sendNotification', {
                            type: 'danger',
                            message: this.$i18n.t('errors.server.access'),
                            icon: icons.error
                        });
                        this.error = e;
                    }
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        getConfigurable(product) {
            if (product.configurableAttributes?.length > 0 && product.children?.length > 0) {
                this.configurables = {};

                for (const attr of product.configurableAttributes) {

                    const defaultChild = product.children.find((child) => {
                        if (child.defaultOffer) {
                            return child.defaultOffer.id === product.defaultOfferId
                        }
                    })
                    if (defaultChild) {
                        const attrValue = {
                            label: defaultChild.attributeValuesByAttributeName[attr]?.label || this.$i18n.t('Choose an option'),
                            options: {},
                            selected: null,
                            type: product.attributeValuesByAttributeName[attr]?.attributeType
                        };
                        // Find difference between all children for a configurable attribute
                        for (const p of product.children) {
                            const value = p.attributeValuesByAttributeName[attr]?.value;

                            const defaultValue = defaultChild.attributeValuesByAttributeName[attr]?.value

                            if (value === defaultValue) {
                                attrValue.selected = value
                            }
                            if (Object.keys(attrValue.options).indexOf(value) === -1 && value) {
                                attrValue.options[value] = 'enabled';
                            }
                        }
                        // set only if has more than 1 option  in attrValue.options
                        if (Object.keys(attrValue.options).length > 1) {
                            // Need to set new value with Vue.set method to preserve reactivity
                            attrValue.options = Object.keys(attrValue.options).sort().reduce((r, k) => (r[k] = attrValue.options[k], r), {})
                            this.$set(this.configurables, attr, attrValue);
                        }
                    }
                }
            }
        },
        selectConfigurableOption(key, option, remove) {
            // Check if option is disable
            if (this.configurables[key].options[option] === 'disabled') return;

            const selectOption = (key, option) => {
                // Set new value with Vue.set method to preserve reactivity
                this.$set(this.configurables[key], 'selected', option);

                Object.keys(this.configurables).forEach(k => {
                    if (k && k != key) {
                        const enabledOptions = [];

                        for (const p of this.product.children) {
                            // For all children, check if attribute value is same than option
                            if (p.attributeValuesByAttributeName[key]?.value === option) enabledOptions.push(p.attributeValuesByAttributeName[k]?.value);
                        }
                        Object.keys(this.configurables[k].options).forEach(option => {
                            // Disabled all configurables button that don't contain the same option
                            if (!enabledOptions.includes(option)) this.configurables[k].options[option] = 'disabled';
                        });
                    }
                });
            };

            const selectProduct = () => {
                let matchingProducts = [...this.product.children];

                Object.keys(this.configurables).forEach(k => {
                    const selected = this.configurables[k].selected
                    if (selected) matchingProducts = matchingProducts.filter(p => p.attributeValuesByAttributeName[k]?.value == selected);
                });

                this.selectedProduct = matchingProducts[0];
                this.setBreadcrumbs()
            };

            const unSelectOption = (key) => {
                this.$set(this.configurables[key], 'selected', null);

                // Reset all disabled options
                Object.keys(this.configurables).forEach(k => {
                    Object.keys(this.configurables[k].options).forEach(option => {
                        this.configurables[k].options[option] = 'enabled';
                    });
                });
                // Replay all selected options
                Object.keys(this.configurables).forEach(k => {
                    if (this.configurables[k].selected && k !== key) this.selectConfigurableOption(k, this.configurables[k].selected, true);
                });
            };

            if (this.configurables[key].selected == null || remove) selectOption(key, option);
            else if (this.configurables[key].selected === option && !remove) unSelectOption(key);
            else if (this.configurables[key].selected !== option) {
                unSelectOption(key);
                selectOption(key, option);
            }
            selectProduct();
        },

        addToCart(params) {
            let cart = params.currentCart,
                itemIsInCart = null,
                qty = Vue.filter('toInt')(params.quantity),
                prevQty = 0,
                stock = params.stock;

            if (cart && cart.cartItems && cart.cartItems.length) {
                itemIsInCart = cart.cartItems.find(item => item.product?.offer?.id === params.offerId);

                if (itemIsInCart) {
                    prevQty = itemIsInCart?.quantity || 0;
                    stock = itemIsInCart?.product.offer.stockQuantity || 0;
                }
            }

            if (prevQty + qty > stock) {
                this.$store.dispatch('sendNotification', {
                    type: 'info',
                    message: this.$i18n.t("addToCart.max"),
                    icon: icons.info
                });

            } else {
                this.AddTocartLoading = true;
                Api.cart.setOfferQuantity(params)
                    .then(data => {
                        this.$store.dispatch('setCart', data);
                        GtagEvent.AddToCart(this.selectedProduct, qty, this.activeCategory, this.currentCart)
                        this.$store.dispatch('toggleProductsActionModal', {
                            open: true,
                            type: params.method,
                            product: this.product.name
                        });
                        this.$store.dispatch('sendNotification', {
                            type: 'info',
                            message: this.$i18n.t('addToCart.add'),
                            icon: icons.info
                            //icons.cart
                        });
                        if (!window['disable-facebook']) {

                            fbq('track', "AddToCart");
                        }
                    })
                    .catch((e) => {
                        this.$store.dispatch('sendNotification', {
                            type: 'danger',
                            message: this.$i18n.t('errors.server.access'),
                            icon: icons.error
                        });
                        this.error = e;
                    })
                    .finally(() => {
                        this.AddTocartLoading = false
                    });
            }
            this.quantity = 1;
        },
        onShareBtnClick(shareOption) {
            window.open(shareOption.baseUrl + this.urlEncode, '', 'menubar=no,toolbar=no,resizable=yes,scrollbars=yes' + shareOption.frameSize);
        },
        onWishlistBtnClick() {
            this.$set(this.selectedProduct, "wishlist", !this.selectedProduct.wishlist);
        },
        onPrintBtnClick() {
            window.print();
        },
        setBreadcrumbs() {

            this.breadcrumbs = [{
                text: this.$t('Home'),
                link: '/'
            }];
            if (this.product.categoryPaths && this.product.categoryPaths.length > 0) {
//get category path of selected product
                const productCategory = this.product.categoryPaths;

                let splitPath = null
                // get only the first category

                if (this.activeCategory) {
                    splitPath = this.product.categoryPaths.find(categ => {
                        if (categ.includes(this.activeCategory)) {
                            return true;
                        }
                    }) || null;

                    if (splitPath) {
                        splitPath = splitPath.split('/');
                    } else {
                        splitPath = productCategory[0].split('/');
                    }
                } else {
                    splitPath = productCategory[0].split('/');
                }
                const tempArr = [];
                if (splitPath) {
                    for (let i of splitPath)
                        i && tempArr.push(i); // copy each non-empty value to the 'temp' array

                    splitPath = tempArr;

                    const categoriesPath = []
// get all path for categories child
                    for (let i = 0, n = splitPath.length; i + 1 <= n; i++) {
                        if (i === 0)
                            categoriesPath.push('/' + splitPath[i]);
                        else categoriesPath.push(categoriesPath[i - 1] + '/' + splitPath[i])
                    }

//create categories breadcrumbs
                    const categoriesBreadcrumbs = [];

                    for (let i = 0, n = categoriesPath.length; i + 1 <= n; i++) {
                        //get data for the category with categoryTree
                        let categ = filterData(this.categoryTree.children, function (item) {
                            return item.path === categoriesPath[i]
                        })[0];

                        if (categ) {

                            // add categories to breadcrumbs
                            // if is the first entry
                            if (i === 0) {
                                categoriesBreadcrumbs.push({
                                    link: '/categorie/' + categ.slug,
                                    text: categ.label
                                })
                            }
                            //for other
                            else {
                                categoriesBreadcrumbs.push({
                                    link: categoriesBreadcrumbs[i - 1]['link'] + '/' + categ.slug,
                                    text: categ.label
                                })
                            }
                        }
                    }
                    //add product to breadcrumbs
                    this.breadcrumbs = this.breadcrumbs.concat(categoriesBreadcrumbs);
                }
            }
            this.breadcrumbs.push({
                link: '',
                text: this.selectedProduct.name ?? this.product.name
            })
            this.breadcrumbsLD = OpenGraph.generateBreadcrumb(this.breadcrumbs)
        },
    },
};
</script>
